import { render } from "./ContactForm.vue?vue&type=template&id=a5ca849c"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__